import type { Student } from '@/types/composition-functions';
import { getClassroomSectionLabel } from '@/utils/classroomLabel';

/** One row of the admin global student search. */
export interface StudentSearchRow {
  id: string
  dbId: string
  firstname: string
  surname?: string | null
  gender?: string | null
  class: string
  email?: string | null
  actions: string
}

/**
 * Flattens a student for the search table. The class column is the section's
 * display name ("JSS 2 Gold"), never its primary key: the payload already
 * carries the section, its classroom and the school type the label needs.
 */
export function toStudentSearchRow(student: Student): StudentSearchRow {
  const section = student.currentClassroomSection ?? null;
  return {
    id: student.matric_no,
    dbId: String(student.id),
    firstname: student.first_name,
    surname: student.surname,
    gender: student.gender,
    class: getClassroomSectionLabel(section, section?.classroom, section?.school?.school_type) || '—',
    email: student.email,
    actions: '',
  };
}
